export default __webpack_public_path__ + "static/media/gateway_behind_nat_visual.f6db50dd.png";